<template>
  <div class="fatherBox">
    <GmapMap
      :center="center"
      :zoom="10"
      style="width: 100%; height: 100vh"
      @center_changed="updateCenter"
      @click="onOFF = false"
    >
      <!-- center 初始化地图位置  zoom地图大小 -->
      <!-- position地图位置  -->
      <GmapMarker
        v-for="(m, index) in markers"
        :key="index"
        :position="m.position"
        :icon="options"
        :options="options"
        @click="openDetails(m)"
      ></GmapMarker>
    </GmapMap>
    <div class="view" v-if="onOFF">
      <div>
        <span class="lable">{{ $18nText(12) }}：</span>
        <span class="content">{{ detailsForm.nickName }}</span>
      </div>
      <div>
        <span class="lable">{{ $18nText(27) }}：</span>
        <span class="content">{{ detailsForm.signature }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { gmapApi } from 'vue2-google-maps';
import { listNearbyUsers, updateShareMapStatus } from '@/api/carMap';
import { listAppResource } from '@/api/user';
export default {
  data() {
    return {
      center: {
        lat: this.$route.query.latitude,
        lng: this.$route.query.longitude
      }, // 地图中心位置
      markers: [],
      detailsForm: {},
      options: {
        url: require('../../assets/car.png')
      },
      onOFF: false
    };
  },
  computed: {
    ...mapGetters(['languageList'])
  },
  activated() {},
  watch: {
    languageList(newData) {
      let { latitude, longitude } = this.$route.query;
      let $18nText23 = newData.find(item => item.id === 23).value,
        $18nText25 = newData.find(item => item.id === 25).value,
        $18nText24 = newData.find(item => item.id === 24).value;
      this.$dialog
        .confirm({
          title: ' ',
          message: $18nText23 + '?',
          confirmButtonText: $18nText25,
          cancelButtonText: $18nText24
        })
        .then(() => {
          // on confirm
          updateShareMapStatus({
            latitude: latitude || 22.54286,
            longitude: longitude || 114.05956,
            status: 1
          }).then(res => {
            this.firstList();
          });
        })
        .catch(() => {
          // on cancel
          // this.$router.go(-1);
          updateShareMapStatus({
            latitude: latitude || 22.54286,
            longitude: longitude || 114.05956,
            status: 0
          }).then(res => {
            this.$winOpen({ path: 'clearPage' });
          });
        });
    }
  },
  methods: {
    updateCenter(center) {
      let center1 = {
        lat: center.lat(),
        lng: center.lng()
      };
    },
    firstList() {
      let { lid, prodNo } = this.$route.query;
      listAppResource({ prodNo }).then(res => {
        this.options.url = res.data.vehicleLogo;
      });

      listNearbyUsers({ lid }).then(res => {
        let newData = [];
        res.data.forEach((item, index) => {
          if (item.isMyself) {
            this.center = {
              lat: item.latitude,
              lng: item.longitude
            };
          } else if (index == 0) {
            this.center = {
              lat: item.latitude,
              lng: item.longitude
            };
          }
          newData.push({
            position: {
              lat: item.latitude,
              lng: item.longitude
            },
            detailsForm: {
              nickName: item.nickName,
              signature: item.signature
            }
          });
        });
        this.markers = newData;
      });
    },
    openDetails(row) {
      this.detailsForm = row.detailsForm;
      this.onOFF = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.view {
  width: 6.5rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 0.2rem rgba(0, 0, 0, 0.16);
  border-radius: 0.2rem;
  position: fixed;
  top: 0.27rem;
  left: calc(50% - 6.9rem / 2);
  padding: 0.2rem;
  div {
    font-size: 0.28rem;
    .lable {
      vertical-align: top;
      display: inline-block;
      width: 1.6rem;
      font-weight: 400;
      line-height: 0.4rem;
      margin: 0.05rem 0;
      color: rgba(0, 0, 0, 1);
    }
    .content {
      width: 4.88rem;
      display: inline-block;
      font-weight: 400;
      line-height: 0.5rem;
      color: rgba(78, 78, 78, 1);
    }
  }
}
</style>
